<!-- <p>bottom-action-bar works!</p> -->
<one-bottom-nav appearance="secondary" class="cn-action-bar-bottom">
    <div class="cn-button-row">
        <div class="cn-button-box">
          <button (click)="discardDraftNotification()" [disabled]="isButtonDisabled" mat-stroked-button one-secondary-button style="color: #cc0033;">
            Delete
          </button>
        </div>
        <div class="cn-button-box">
          <button (click)="saveCloseNotification()" [disabled]="isButtonDisabled" mat-stroked-button one-secondary-button>
            Save and close
          </button>
        </div>
        <div class="cn-button-box">
          <button (click)="btnPrevNextStepClicked('prev')" [disabled]="btnState.isPrevDisabled || isButtonDisabled" mat-stroked-button one-secondary-button>
              Previous step
          </button>
        </div>
        <div class="cn-button-box">
          <button (click)="btnPrevNextStepClicked('next')" *ngIf="!btnState.isNextDisabled" [disabled]="btnState.isNextDisabled || isButtonDisabled" color="primary" mat-flat-button>
              Next step
          </button>
         <button (click)="btnSendNotificationClicked()" color="primary" mat-flat-button *ngIf="btnState.isNextDisabled && userPermission.SendNotification" [disabled]="isSendNotificationEnabled || isButtonDisabled">
            Send Notification
        </button>
        </div>
      </div>
</one-bottom-nav>